@if (wip()?.length > 0) {
  <div
    #progressPanel
    class="request-progress-panel request-progress-panel-initial"
    [ngClass]="{ 'request-progress-panel-collapsed': !panelExpanded() }"
    draggable="true"
    (dragstart)="DragElementService.getDrapgPoint(progressPanel, $event)"
    (dragend)="
      DragElementService.setPosition(
        progressPanel,
        $event,
        'request-progress-panel-initial',
        '--progress-panel-y',
        '--progress-panel-x'
      )
    "
  >
    <div
      class="request-progress-card-title"
      [ngClass]="{ 'request-progress-card-title-collapsed': !panelExpanded() }"
    >
      <!-- Scroll and title -->
      @if (panelExpanded()) {
        <span>{{ "tasks-progress" | translate }}</span>
      }
      <!-- Expand/Collapse -->
      <div>
        <i
          [ngClass]="panelExpanded() ? 'fas fa-compress-alt' : 'fas fa-expand-alt'"
          class="pointer"
          (click)="panelExpanded.update(v => !v)"
        ></i>
        <i
          [ngClass]="'fas fa-times'"
          class="pointer"
          (click)="
            SessionDataService.sendTaskAction({
              index: null,
              action: 'cancelAll'
            })
          "
          title="{{ 'cancel-all-task' | translate }}"
        ></i>
      </div>
    </div>
    <!-- Tasks in progress -->
    <div class="request-progress-panel-tasks">
      @for (task of wip(); track task.name; let i = $index) {
        <!-- Expanded panel -->
        @if (panelExpanded()) {
          <div class="request-progress-panel-task">
            <div class="request-progress-task-actions">
              <div
                class="request-progress-task-show"
                title="{{ 'show-detail' | translate }}"
                (click)="goToProgressTable(task)"
              >
                <i class="fas fa-eye"></i>
              </div>
              <div
                class="request-progress-task-show"
                title="{{ 'cancel-task' | translate }}"
                (click)="
                  SessionDataService.sendTaskAction({
                    index: task.taskIndex,
                    action: 'cancel'
                  })
                "
              >
                <i class="fas fa-times"></i>
              </div>
            </div>
            <div class="request-progress-task-title">{{ task.name }}</div>
            @if (task.action != "reassignManually") {
              <div>
                <!-- Progress bar -->
                <div class="request-progress-task-bar progress">
                  <div
                    class="progress-bar progress-bar-striped"
                    [ngClass]="
                      task.progress == 100
                        ? 'bg-success'
                        : task.error > 0
                          ? 'bg-danger'
                          : 'progress-bar-animated bg-info'
                    "
                    role="progressbar"
                    attr.aria-valuenow="{{ task.progress | number: '1.0-0' }}"
                    [style.width]="task.progress + '%'"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    @if (task.progress == 100) {
                      <b>{{ "finished" | translate }}</b>
                    }
                    @if (task.progress != 100) {
                      <b class="progress-bar-text">
                        {{ task.progress | number: "1.0-0" }}%
                        <span>({{ task.progressIndex }}/{{ task.taskData?.length }})</span>
                      </b>
                    }
                  </div>
                </div>
                <div>
                  <!-- Stop -->
                  @if (task.status == "run" && task?.progress != 100) {
                    <button
                      type="button"
                      class="request-progress-task-button"
                      title="{{ 'request-stop' | translate }}"
                      (click)="
                        SessionDataService.sendTaskAction({
                          index: task.taskIndex,
                          action: 'stop'
                        })
                      "
                    >
                      <i class="fas fa-stop"></i>
                    </button>
                  }
                  <!-- Resume -->
                  @if (task.status == "stop" && task?.progress != 100) {
                    <button
                      type="button"
                      class="request-progress-task-button"
                      title="{{ 'request-start' | translate }}"
                      (click)="
                        SessionDataService.sendTaskAction({
                          index: task.taskIndex,
                          action: 'run'
                        })
                      "
                    >
                      <i class="fas fa-play"></i>
                    </button>
                  }
                  <!-- Retry -->
                  @if (task.progress == 100) {
                    <button
                      type="button"
                      class="request-progress-task-button"
                      title="{{ 'retry-failed' | translate }}"
                      (click)="
                        SessionDataService.sendTaskAction({
                          index: task.taskIndex,
                          action: 'retry'
                        })
                      "
                      [disabled]="task.error == 0"
                    >
                      <i class="fas fa-redo-alt"></i>
                    </button>
                  }
                </div>
                <div>
                  <!-- Correctos -->
                  <span>
                    <i class="fas fa-check-circle"></i>
                    {{ task.success }}
                  </span>
                  <!-- Errors -->
                  <span>
                    <i class="fas fa-times-circle"></i>
                    {{ task.error }}
                  </span>
                </div>
              </div>
            }
          </div>
        }
        <!-- Collapsed panel -->
        @if (!panelExpanded()) {
          <div class="request-progress-panel-task-collapsed">
            <!-- Progress bar -->
            <div class="request-progress-task-bar">
              <div
                class="progress-bar"
                [ngClass]="
                  task.progress == 100
                    ? 'progress-bar-success progress-bar-striped '
                    : task.error > 0
                      ? 'progress-bar-danger progress-bar-striped '
                      : 'progress-bar-striped active'
                "
                role="progressbar"
                attr.aria-valuenow="{{ task.progress | number: '1.0-0' }}"
                [style.width]="task.progress + '%'"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <b>{{ task.progress | number: "1.0-0" }}%</b>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
}
